import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAnnotationTypeStore = defineStore('anntypes', () => {
  const selectedDisplayTypes = ref([]);
  const jsonViewerShowTypes = ref({
    image: true,
    box: true,
    seg: true,
    pcd: false,
    json: false,
    '3dbox': false,
    depthmap: false,
  });

  function $reset() {
    selectedDisplayTypes.value = [];
    jsonViewerShowTypes.value = {
      image: true,
      box: true,
      seg: true,
      pcd: false,
      json: false,
      '3dbox': false,
      depthmap: false,
    };
  }

  return {
    jsonViewerShowTypes,
    selectedDisplayTypes,
    $reset,
  };
});
